import './IntegrationContinuous.css';

export default function IntegrationContinuous() {
  const cards = [
    {
      id: 1,
      percentage: '41%',
      description: 'Traditional Ops is 41% more time-consuming overall',
      bg:"#E7F3FF"
    },
    {
      id: 2,
      percentage: '41%',
      description: 'Traditional Ops is 41% more time-consuming overall',
       bg:"#F7EBFF"
    },
    {
      id: 3,
      percentage: '41%',
      description: 'Traditional Ops is 41% more time-consuming overall',
       bg:"#FFF4E6"
    },
    {
      id: 4,
      percentage: '41%',
      description: 'Traditional Ops is 41% more time-consuming overall',
       bg:"#F0ECFB"
    }
  ];

  return (
    <div id="integration-continuous" className='outsourcemainclass'>
      <div className="left">
        <h2 className="heading">What Is Continuous Integration?</h2>
        <p className="subheading">
          Continuous Integration (CI) is a core DevOps practice that enables
          developers to regularly integrate code changes into a centralized
          repository. Each update is automatically built, tested, and validated
          through predefined pipelines, ensuring code quality and consistency.
          By continuously verifying every change, CI helps teams detect bugs and
          integration issues at an early stage, reducing rework and deployment
          risks. This approach enhances collaboration among development and QA
          teams, maintains a stable and reliable codebase, and supports faster,
          more efficient software delivery across the entire development
          lifecycle.
        </p>
      </div>
      <div className="right">
        <div className="cards">
          {cards.map((card) => (
            <div key={card.id} className="card" style={{backgroundColor:card.bg}}>
              <h1>{card.percentage}</h1>
              <span>{card.description}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}